// Where a job card stands at each production stage. One source of truth for the
// operator screens and the Floor status box, so "pending" means the same thing
// everywhere.
import { pressingProgress } from './pressing';

// Cards still on the floor (the statuses operators can see)
export const ON_FLOOR = ['in_production', 'in_progress'];
export const isOnFloor = (jc) => ON_FLOOR.includes(jc?.status);

// Which stages a card goes through, by card type (same rule as the operator lists)
export const needsCutting = (jc) => ['combined', 'cutting'].includes(jc?.card_type);
export const needsBoring = (jc) => ['combined', 'work_details'].includes(jc?.card_type);
export const needsPressing = (jc) => pressingProgress(jc).hasPressing;

// 'not_started' | 'started' | 'completed'
// A cutting quantity counts as real cutting only with a machine: operators must
// pick one, while the coordinator's Work Details form can type a cutting number
// too (the planned-vs-actual field is still shared). Without this check a
// coordinator's plan would show as "In progress".
export const cuttingStage = (jc) => {
  if (jc?.cutting_status === 'completed') return 'completed';
  const operatorCut = (jc?.cutting_qty_total || 0) > 0 && (jc?.cutting_machine_id || jc?.cutting_machine_number);
  if (jc?.cutting_status === 'started' || operatorCut) return 'started';
  return 'not_started';
};

// Boring is finished only when the operator taps Finish. Cards from before the
// Finish button read as in progress once they have any boring entry.
export const boringStage = (jc) => {
  if (jc?.boring_status === 'completed') return 'completed';
  if (jc?.boring_status === 'started' || jc?.boring_updated || (jc?.boring_qty_total || 0) > 0) return 'started';
  return 'not_started';
};

export const STAGE_LABEL = { not_started: 'Not started', started: 'In progress', completed: 'Finished' };
export const STAGE_CHIP = {
  not_started: 'bg-red-100 text-red-800',
  started: 'bg-amber-100 text-amber-800',
  completed: 'bg-green-100 text-green-800',
};
